export const EXPENSES_RECIEVED = "EXPENSES_RECIEVED"
export const EXPENSE_SAVED = "EXPENSE_SAVED"
export const EXPENSE_DELETED = "EXPENSE_DELETED"
export const EXPENSE_UNLOADED = "EXPENSE_UNLOADED"
